import React from 'react';
import PropTypes from 'prop-types';
// material ui
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Tooltip from '@mui/material/Tooltip';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import StickyButtonBar from '../../components/common/StickyButtonBar';

/**
 * BreweryActionBar renders the sticky action buttons for the Brewery page.
 * It shows Save, Change Logo, and Delete Brewery buttons. Save submits a target form by id.
 */
function BreweryActionBar({
  formId,
  onChangeLogo,
  onDelete,
  saveDisabled,
  deleteDisabled,
  deleteBusy,
  deleteTooltip,
  showDeleteInfo,
}) {
  const deleteButton = (
    <Button
      variant="contained"
      color="error"
      aria-label="Delete brewery"
      onClick={onDelete}
      disabled={Boolean(deleteDisabled)}
      startIcon={
        deleteBusy ? <CircularProgress size={20} color="inherit" /> : null
      }
      endIcon={!deleteBusy && showDeleteInfo ? <PriorityHighIcon /> : null}
    >
      {deleteBusy ? 'Checking...' : 'Delete Brewery'}
    </Button>
  );

  return (
    <StickyButtonBar>
      {showDeleteInfo ? (
        <Tooltip title={deleteTooltip} placement="top" arrow>
          <span>{deleteButton}</span>
        </Tooltip>
      ) : (
        deleteButton
      )}
      <Button
        variant="contained"
        color="primary"
        aria-label="Edit brewery logo"
        onClick={onChangeLogo}
      >
        Change Logo
      </Button>
      <Button
        variant="contained"
        color="primary"
        type="submit"
        form={formId}
        disabled={Boolean(saveDisabled)}
      >
        Save
      </Button>
    </StickyButtonBar>
  );
}

BreweryActionBar.propTypes = {
  formId: PropTypes.string.isRequired,
  onChangeLogo: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  saveDisabled: PropTypes.bool,
  deleteDisabled: PropTypes.bool,
  deleteBusy: PropTypes.bool,
  deleteTooltip: PropTypes.string,
  showDeleteInfo: PropTypes.bool,
};

BreweryActionBar.defaultProps = {
  saveDisabled: false,
  deleteDisabled: false,
  deleteBusy: false,
  deleteTooltip: '',
  showDeleteInfo: false,
};

export default BreweryActionBar;

